<template lang="pug">
  WtTile(child :col="12")
    WtTitle.mt-1.mb-1 Existing {{pluralize(_.get(coreProgramMeta, "organizationsName", "Organization"))}}
    ExistingOrganizationsTable(
      :organizations="organizations || []"
    )
</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import WtButton from "@@/WtButton/WtButton";
import ExistingOrganizationsTable from "@@/OrganizationsSettingsAdmin/ExistingOrganizationsTable";
import { mapGetters } from "vuex";
export default {
  name: "ExistingOrganizations",

  components: {
    WtTitle,
    WtTile,
    WtButton,
    ExistingOrganizationsTable
  },
  computed: {
    ...mapGetters("organizations", ["organizations"]),
    ...mapGetters("program", ["coreProgramMeta"])
  }
};
</script>

<style lang="sass"></style>
